webpackJsonp([116453730430729],{

/***/ 722:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Apprenticeship":"src-components-Destination-Apprenticeship----Apprenticeship-module---Apprenticeship---2zwNt","Apprenticeship__Wrapper":"src-components-Destination-Apprenticeship----Apprenticeship-module---Apprenticeship__Wrapper---2Ot9c","Apprenticeship__Intro":"src-components-Destination-Apprenticeship----Apprenticeship-module---Apprenticeship__Intro---HfpDw","Cards":"src-components-Destination-Apprenticeship----Apprenticeship-module---Cards---2FLmm","Cards__Link":"src-components-Destination-Apprenticeship----Apprenticeship-module---Cards__Link---1oOTd","Cards__Item":"src-components-Destination-Apprenticeship----Apprenticeship-module---Cards__Item---1ZqyZ"};

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ApprenticeshipModule = __webpack_require__(722);
	
	var _ApprenticeshipModule2 = _interopRequireDefault(_ApprenticeshipModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Apprenticeship = function Apprenticeship(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: _ApprenticeshipModule2.default.Apprenticeship, id: props.identifier },
	        _react2.default.createElement(
	            'div',
	            { className: _ApprenticeshipModule2.default.Apprenticeship__Wrapper },
	            _react2.default.createElement(
	                'h2',
	                null,
	                props.title
	            ),
	            props.intro && _react2.default.createElement(
	                'p',
	                { className: '' + _ApprenticeshipModule2.default.Apprenticeship__Intro },
	                props.intro.apprenticeshipIntro
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _ApprenticeshipModule2.default.Cards },
	                props.cards.map(function (card, i) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: i },
	                        card.link && _react2.default.createElement(
	                            'div',
	                            { className: _ApprenticeshipModule2.default.Cards__Item + ' apprenticeships-card' },
	                            _react2.default.createElement('a', { href: '/' + card.link + '/', target: '_blank', className: '' + _ApprenticeshipModule2.default.Cards__Link }),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                card.title
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                card.text.text
	                            )
	                        ),
	                        !card.link && _react2.default.createElement(
	                            'div',
	                            { className: _ApprenticeshipModule2.default.Cards__Item + ' apprenticeships-card' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                card.title
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                card.text.text
	                            )
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	exports.default = Apprenticeship;
	module.exports = exports['default'];

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Details":"src-components-Destination-CountryDetails----CountryDetails-module---Details---3jVyG","Details__Hide":"src-components-Destination-CountryDetails----CountryDetails-module---Details__Hide---1EWL9","Details__Wrapper":"src-components-Destination-CountryDetails----CountryDetails-module---Details__Wrapper---u61sA","Details__Box":"src-components-Destination-CountryDetails----CountryDetails-module---Details__Box---1vgyb","Details__Box__Items":"src-components-Destination-CountryDetails----CountryDetails-module---Details__Box__Items---32K0n"};

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _CountryDetailsModule = __webpack_require__(724);
	
	var _CountryDetailsModule2 = _interopRequireDefault(_CountryDetailsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CountryDetails = function CountryDetails(props) {
		return _react2.default.createElement(
			'div',
			{ className: _CountryDetailsModule2.default.Details__Wrapper, ref: props.callbackRef },
			_react2.default.createElement(
				'div',
				{
					className: _CountryDetailsModule2.default.Details + ' ' + (props.showCountryDetails ? '' : _CountryDetailsModule2.default.Details__Hide)
				},
				_react2.default.createElement(
					'div',
					{ className: _CountryDetailsModule2.default.Details__Box },
					_react2.default.createElement('img', { src: props.locationMap.file.url, alt: props.locationMap.title }),
					_react2.default.createElement(
						'div',
						{ className: _CountryDetailsModule2.default.Details__Box__Items },
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								null,
								'Language Spoken:'
							),
							_react2.default.createElement(
								'p',
								null,
								props.language
							)
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								null,
								'Time Zone:'
							),
							_react2.default.createElement(
								'p',
								null,
								props.timeZone
							)
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								null,
								'Currency:'
							),
							_react2.default.createElement(
								'p',
								null,
								props.currency
							)
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								null,
								'Apprenticeships:'
							),
							_react2.default.createElement(
								'p',
								null,
								props.apprenticeships.map(function (app, i) {
									return _react2.default.createElement(
										'span',
										{ key: i },
										app,
										i == props.apprenticeships.length - 1 ? '' : ', '
									);
								})
							)
						)
					)
				),
				_react2.default.createElement(
					_gatsbyLink2.default,
					{ className: 'button', to: '/interest-form/' },
					'Learn More'
				)
			)
		);
	};
	
	exports.default = CountryDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Culture":"src-components-Destination-Culture----Culture-module---Culture---2Lp-5","Culture__Wrapper":"src-components-Destination-Culture----Culture-module---Culture__Wrapper---KMBlF","Culture__Item":"src-components-Destination-Culture----Culture-module---Culture__Item---3z77U"};

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CultureModule = __webpack_require__(725);
	
	var _CultureModule2 = _interopRequireDefault(_CultureModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Culture = function Culture(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _CultureModule2.default.Culture },
	    _react2.default.createElement(
	      'div',
	      { className: _CultureModule2.default.Culture__Wrapper },
	      _react2.default.createElement(
	        'h2',
	        null,
	        props.title
	      ),
	      props.cards.map(function (card, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: _CultureModule2.default.Culture__Item, key: i },
	          _react2.default.createElement(
	            'h3',
	            null,
	            card.title
	          ),
	          card.text && _react2.default.createElement(
	            'p',
	            null,
	            card.text.text
	          ),
	          card.mediaAsset && _react2.default.createElement('img', { src: card.mediaAsset.file.url, alt: card.mediaAsset.title })
	        );
	      })
	    )
	  );
	};
	
	exports.default = Culture;
	module.exports = exports['default'];

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Experience":"src-components-Destination-Experience----Experience-module---Experience---zP03f","Experience__Title":"src-components-Destination-Experience----Experience-module---Experience__Title---3SAFG","Experience__Wrapper":"src-components-Destination-Experience----Experience-module---Experience__Wrapper---29bgX"};

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExperienceModule = __webpack_require__(726);
	
	var _ExperienceModule2 = _interopRequireDefault(_ExperienceModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Experience = function Experience(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _ExperienceModule2.default.Experience, id: props.identifier },
	    _react2.default.createElement(
	      'div',
	      { className: _ExperienceModule2.default.Experience__Wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _ExperienceModule2.default.Experience__Title },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Your Experience'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        props.title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        props.text
	      ),
	      _react2.default.createElement('img', { src: props.featuredImage.file.url, alt: props.featuredImage.title })
	    )
	  );
	};
	
	exports.default = Experience;
	module.exports = exports['default'];

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Hero":"src-components-Destination-Hero----Hero-module---Hero---39f9i","Hero__Wrapper":"src-components-Destination-Hero----Hero-module---Hero__Wrapper---2_xNt","Hero__Title":"src-components-Destination-Hero----Hero-module---Hero__Title---ZH3s-","Hero__Title__Reduced":"src-components-Destination-Hero----Hero-module---Hero__Title__Reduced---1HIGC","Hero__Title__Academy":"src-components-Destination-Hero----Hero-module---Hero__Title__Academy---TW1n3","Hero__Info":"src-components-Destination-Hero----Hero-module---Hero__Info---3HfGE"};

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeroModule = __webpack_require__(307);
	
	var _HeroModule2 = _interopRequireDefault(_HeroModule);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var academyPages = ['/academy', '/academy/', '/academy/interest', '/academy/interest/', '/academy/experience', '/academy/experience/'];
	var Hero = function Hero(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page-hero ' + _HeroModule2.default.Hero + (academyPages.includes(props.location) || props.admissionsTemplate ? ' academy' : '') },
	    _react2.default.createElement(
	      'div',
	      { className: _HeroModule2.default.Hero__Wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _HeroModule2.default.Hero__Info },
	        _react2.default.createElement(
	          'div',
	          { className: academyPages.includes(props.location) || props.admissionsTemplate ? _HeroModule2.default.Hero__Title__Academy : _HeroModule2.default.Hero__Title },
	          _react2.default.createElement('h1', { dangerouslySetInnerHTML: { __html: props.title } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hero-img-wrap' },
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: props.featuredImage.sizes, alt: props.featuredImage.title }),
	          props.caption && _react2.default.createElement(
	            'p',
	            { className: 'small-hero-caption' },
	            props.caption
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          props.description
	        )
	      )
	    )
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Quote":"src-components-Destination-Quote----Quote-module---Quote---17TOp","Quote__Wrapper":"src-components-Destination-Quote----Quote-module---Quote__Wrapper---Lfl2A","Quote__Details":"src-components-Destination-Quote----Quote-module---Quote__Details---3MG5L","Quote__Text":"src-components-Destination-Quote----Quote-module---Quote__Text---20Z21"};

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _QuoteModule = __webpack_require__(166);
	
	var _QuoteModule2 = _interopRequireDefault(_QuoteModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quote = function Quote(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: _QuoteModule2.default.Quote },
	        _react2.default.createElement(
	            'div',
	            { className: _QuoteModule2.default.Quote__Wrapper },
	            _react2.default.createElement(
	                'div',
	                { className: _QuoteModule2.default.Quote__Details },
	                props.image && _react2.default.createElement('img', { className: 'profile-image', src: props.image.file.url, alt: props.image.title }),
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    props.title
	                ),
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: 'hoverlink c-white', to: props.link.link },
	                    props.link.text
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _QuoteModule2.default.Quote__Text + ' quote-text' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    props.text
	                )
	            )
	        )
	    );
	};
	
	exports.default = Quote;
	module.exports = exports['default'];

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Regions":"src-components-Destination-Regions----Regions-module---Regions---qmvgq","Regions__Wrapper":"src-components-Destination-Regions----Regions-module---Regions__Wrapper---3iMSI","Region":"src-components-Destination-Regions----Regions-module---Region---3R1YE","Region__Image":"src-components-Destination-Regions----Regions-module---Region__Image---202tV","Region__Image__Image":"src-components-Destination-Regions----Regions-module---Region__Image__Image---3jY8G","Region__Description":"src-components-Destination-Regions----Regions-module---Region__Description---3X6jI","Region__Details":"src-components-Destination-Regions----Regions-module---Region__Details---p5Utf","Region__Stats":"src-components-Destination-Regions----Regions-module---Region__Stats---2JdHM","Region__Map":"src-components-Destination-Regions----Regions-module---Region__Map---3Lk-J"};

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RegionsModule = __webpack_require__(727);
	
	var _RegionsModule2 = _interopRequireDefault(_RegionsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Regions = function Regions(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _RegionsModule2.default.Regions },
	    _react2.default.createElement(
	      'div',
	      { className: _RegionsModule2.default.Regions__Wrapper },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'The regions'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        props.cards.map(function (region, i) {
	          return _react2.default.createElement(
	            'div',
	            { className: _RegionsModule2.default.Region, key: i },
	            _react2.default.createElement(
	              'h3',
	              null,
	              region.title
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: _RegionsModule2.default.Region__Description },
	              region.text.text
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _RegionsModule2.default.Region__Image + ' para-cont' },
	              _react2.default.createElement('img', { className: _RegionsModule2.default.Region__Image__Image + ' para-item', 'data-speed': '4', src: region.featuredImage.file.url })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _RegionsModule2.default.Region__Details },
	              _react2.default.createElement(
	                'div',
	                { className: _RegionsModule2.default.Region__Stats },
	                region.regionDetails.map(function (detail, iterator) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: iterator },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      detail.title
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      detail.text.text
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _RegionsModule2.default.Region__Map },
	                _react2.default.createElement('img', { src: region.locationImage.file.url, alt: region.locationImage.title })
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = Regions;
	module.exports = exports['default'];

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Hero = __webpack_require__(337);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _BannerImage = __webpack_require__(63);
	
	var _BannerImage2 = _interopRequireDefault(_BannerImage);
	
	var _Regions = __webpack_require__(533);
	
	var _Regions2 = _interopRequireDefault(_Regions);
	
	var _Experience = __webpack_require__(531);
	
	var _Experience2 = _interopRequireDefault(_Experience);
	
	var _Apprenticeship = __webpack_require__(528);
	
	var _Apprenticeship2 = _interopRequireDefault(_Apprenticeship);
	
	var _CountryDetails = __webpack_require__(529);
	
	var _CountryDetails2 = _interopRequireDefault(_CountryDetails);
	
	var _Culture = __webpack_require__(530);
	
	var _Culture2 = _interopRequireDefault(_Culture);
	
	var _Quote = __webpack_require__(153);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollMagic;
	if (typeof window === 'object') {
		ScrollMagic = __webpack_require__(24);
	}
	
	// if(typeof window == 'object') {
	// 	require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
	// }
	
	var DestinationDetail = function (_React$Component) {
		_inherits(DestinationDetail, _React$Component);
	
		function DestinationDetail(props) {
			_classCallCheck(this, DestinationDetail);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.state = {
				showCountryDetails: true,
				controller: null
			};
			return _this;
		}
	
		DestinationDetail.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			var Parallax = {
				init: function init(el, displace, offset) {
					this.animateItem(el, displace, offset);
				},
				setPosition: function setPosition() {
					if (window.pageYOffset !== undefined) {
						return window.pageYOffset;
					} else {
						return (document.documentElement || document.body.parentNode || document.body).scrollTop;
					}
				},
				animateItem: function animateItem(el, displace, offset) {
					if (typeof window.orientation !== 'undefined') {
						return;
					}
					var scrollPosition = this.setPosition();
					el.style.transform = 'translate3d(0px, ' + scrollPosition / displace + 'px, 0px)';
					el.style.marginTop = offset;
				}
			};
	
			this.controller = new ScrollMagic.Controller();
			this.setState({
				controller: this.controller
			});
			setTimeout(function () {
				return _this2.navSceneInit();
			}, 450);
	
			var hideCountryDetails = function hideCountryDetails(elOne, elTwo, elThree, elFour, elFive) {
				if (typeof window.orientation !== 'undefined' || window.innerWidth < 1096) {
					return;
				}
	
				var distanceTopOne = elOne.getBoundingClientRect().top,
				    distanceBottomOne = elOne.getBoundingClientRect().bottom,
				    distanceTopTwo = elTwo.getBoundingClientRect().top,
				    distanceBottomTwo = elTwo.getBoundingClientRect().bottom,
				    distanceTopThree = elThree.getBoundingClientRect().top,
				    distanceBottomThree = elThree.getBoundingClientRect().bottom,
				    distanceTopFour = elFour.getBoundingClientRect().top,
				    distanceBottomFour = elFour.getBoundingClientRect().bottom,
				    distanceTopFive = elFive.getBoundingClientRect().top;
	
				if (distanceTopOne < 750 && distanceBottomOne > 240 || distanceTopTwo < 750 && distanceBottomTwo > 240 || distanceTopThree < 750 && distanceBottomThree > 240 || distanceTopFour < 750 && distanceBottomFour > 240 || distanceTopFive < 750) {
					_this2.setState({
						showCountryDetails: false
					});
				} else {
					_this2.setState({
						showCountryDetails: true
					});
				}
			};
	
			var ScrollReveal = __webpack_require__(149);
	
			var ParaImages = document.querySelectorAll('.para-item'),
			    itemOne = document.querySelector('#bannerOne'),
			    itemTwo = document.querySelector('#experienceSection'),
			    itemThree = document.querySelector('#bannerTwo'),
			    itemFour = document.querySelector('#apprenticeshipSection'),
			    itemFive = document.querySelector('#bannerThree');
	
			var handleScrolling = function handleScrolling() {
				ParaImages[0] && Parallax.init(ParaImages[0], -8.2, '180px');
				ParaImages[1] && Parallax.init(ParaImages[1], -8.2, '350px');
				ParaImages[2] && Parallax.init(ParaImages[2], -8.2, '480px');
	
				hideCountryDetails(itemOne, itemTwo, itemThree, itemFour, itemFive);
			};
	
			window.addEventListener('scroll', handleScrolling);
	
			window.setTimeout(function () {
				window.sr = ScrollReveal();
				sr.reveal('.apprenticeships-card', { duration: 600, delay: 200 }, 80);
				sr.reveal('.profile-image', { duration: 800 });
				sr.reveal('.quote-text', { duration: 1000, delay: 100 });
			}, 200);
		};
	
		DestinationDetail.prototype.componentWillUnmount = function componentWillUnmount() {
			this.state.controller ? this.state.controller.destroy(true) : null;
			this.controller ? this.controller.destroy(true) : null;
		};
	
		DestinationDetail.prototype.navSceneInit = function navSceneInit() {
			var triggerHook = window.innerWidth > 1200 ? 0.3 - 207 / window.innerHeight : null;
	
			if (triggerHook != null) {
				this.navScene = new ScrollMagic.Scene({
					triggerElement: this.pageNav,
					triggerHook: triggerHook
				}).setPin(this.pageNav.children[0]).addTo(this.controller);
				// .addIndicators()
			}
		};
	
		DestinationDetail.prototype.render = function render() {
			var _this3 = this;
	
			var page = this.props.data.page;
	
			var seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : '';
			//console.log('THE DATA ===> ', page);
			// console.log('THE IMAGES ===> ', page.bannerImage, page.secondBannerImage, page.thirdBannerImage);
			return _react2.default.createElement(
				'div',
				{ className: 'dest' },
				_react2.default.createElement(_CustomHelmet2.default, { data: page.seoData }),
				_react2.default.createElement(_CountryDetails2.default, {
					locationMap: page.locationMap,
					language: page.language,
					timeZone: page.timeZone,
					currency: page.currency.currency,
					apprenticeships: page.apprenticeships,
					showCountryDetails: this.state.showCountryDetails,
					callbackRef: function callbackRef(el) {
						return _this3.pageNav = el;
					}
				}),
				_react2.default.createElement(_Hero2.default, {
					title: page.destinationName,
					featuredImage: page.featuredImage,
					description: page.destinationDescription.destinationDescription
				}),
				_react2.default.createElement(_BannerImage2.default, { image: page.bannerImage, identifier: 'bannerOne' }),
				_react2.default.createElement(_Regions2.default, { cards: page.regions }),
				_react2.default.createElement(_Experience2.default, {
					title: page.experienceTitleOne,
					featuredImage: page.experienceImageOne,
					text: page.experienceTextOne.experienceTextOne,
					identifier: 'experienceSection'
				}),
				_react2.default.createElement(_Apprenticeship2.default, {
					title: page.apprenticeshipTitle,
					intro: page.apprenticeshipIntro,
					cards: page.apprenticeshipCards,
					identifier: 'apprenticeshipSection'
				}),
				_react2.default.createElement(_BannerImage2.default, { image: page.secondBannerImage, identifier: 'bannerTwo' }),
				_react2.default.createElement(_Culture2.default, {
					title: page.experienceTitleTwo,
					cards: page.experienceItemsTwo
				}),
				_react2.default.createElement(_BannerImage2.default, { image: page.thirdBannerImage, identifier: 'bannerThree' }),
				_react2.default.createElement(_Quote2.default, {
					image: page.quoteImage,
					title: page.quoteTitle,
					text: page.quoteText.quoteText,
					link: page.quoteLink
				})
			);
		};
	
		return DestinationDetail;
	}(_react2.default.Component);
	
	exports.default = DestinationDetail;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-destination-js-053608455b09ff718fcb.js